<template>
  <div class="copy-event text-dark" ref="copy_event_panel" v-if="isDropdown">
    <transition name="fadeInDown">
      <div class="copy-event__panel" v-if="isDropdownPopperDone">
        <h3 :style="{'backgroundColor': event.color }">
          {{ $t('vue2.copycalendar.copy') }} {{ event.title }}, {{ showDateAndTime }}
        </h3>
        <div class="icon__bg-circle copy-event__panel__close-cross" @click.stop="closeDropdown"><span
          class="icon-cross2"></span></div>
        <div class="copy-event__panel__container">
          <div class="weeks-container">
            <select class="school-year-selector" v-model="componentActiveSchoolYearId">
              <option v-for="year in activeSchoolYears"
                      :value="year.id"
                      :key="year.id">
                {{ year.name }}
              </option>
            </select>
            <ul class="weeks">
              <template v-if="weeks.length < 1">
                <Spinner color="blue" style="margin-bottom: 100px"></Spinner>
              </template>
              <template v-else>
                <li class="weeks__week hint--top"
                    v-for="week in weeks"
                    :key="week.serverDate"
                    :aria-label="tooltipDate(week.date)"
                    :class="[
                {'weeks__week--is-selected': isWeekSelected(week)},
                {'weeks__week--is-copy-week': isCopyWeek(week)}
                ]"
                    @click="setSelectedWeek(week)">
                  {{ week.date | showWeek }}
                  <span class="weeks__week__now-indicator" v-if="isNow(week)"></span>
                </li>
              </template>
            </ul>
          </div>
          <div class="copy-event__panel__sidebar">
            <h4>{{ $t('vue2.copycalendar.markWeeksFrom') }}
              {{ copyDate | showWeek }}</h4>
            <button class="bttn width-100 btn-trans" @click="addAllWeeksOnward">
              {{ $t('vue2.copycalendar.allWeeks') }}
            </button>
            <button class="bttn width-100 btn-trans" @click="selectOddWeeks">
              {{ $t('vue2.copycalendar.oddWeeks') }}
            </button>
            <button class="bttn width-100 btn-trans" @click="selectEvenWeeks">
              {{ $t('vue2.copycalendar.evenWeeks') }}
            </button>
            <button class="bttn btn-trans width-100 btn-remove" @click="removeAllSelectedWeeks">
              {{ $t('vue2.copycalendar.unselectAll') }}
            </button>
          </div>
        </div>
        <div class="copy-event__panel__footer">
          <button class="bttn bttn--disabled" v-if="selectedWeeks.length < 1">{{
              $t('vue2.copycalendar.paste')
            }}
          </button>
          <button @click="submit" v-else>{{ $t('vue2.copycalendar.paste') }}</button>
        </div>
      </div>
    </transition>
    <div class="copy-event__overlay" ref="d_copy_event_overlay" v-if="isDropdown" @click.stop="closeDropdown"></div>
  </div>
</template>

<script>
import docendo from '../../docendo'
import moment from 'moment'
import eventbus from '../../eventbus'
import Spinner from '../common/Spinner'
import {createPopper} from '@popperjs/core'

export default {
  components: {Spinner},
  filters: {
    showWeek (date) {
      return moment(date).isoWeek()
    }
  },
  data () {
    return {
      cal: null,
      calStartDate: null,
      calEndDate: null,
      selectedWeeks: [],
      isDropdown: false,
      isDropdownPopperDone: false,
      componentActiveSchoolYearId: null,
      event: {
        'id': 24035310,
        'calendar_id': 133752,
        'title': 'Billedkunst',
        'color': '#ff7f50',
        'event_time_start': '2020-10-20T06:00:00Z',
        'event_time_end': '2020-10-20T07:00:00Z'
      }
    }
  },
  computed: {
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    copyEventEvent () {
      return eventbus.copyEventEvent
    },
    copyDate () {
      const startDate = this.event.start ? this.event.start : this.event.event_time_start
      return moment(startDate).format('YYYY-MM-DD')
    },
    sourceWeek () {
      return moment(this.copyDate).format('GGGG-WW')
    },
    showStartPasteWeek () {
      return moment(this.startPasteWeek).isSame(this.calStartDate)
    },
    showDateAndTime () {
      const startDate = this.event.start ? this.event.start : this.event.event_time_start
      const endDate = this.event.end ? this.event.end : this.event.event_time_end
      return moment(startDate).format('dddd, LT') + ' - ' + moment(endDate).format('LT')
    },
    weeks () {
      if (!this.componentActiveSchoolYearId) {
        return []
      }
      let activeSchoolYear = this.activeSchoolYears[this.activeSchoolYears.findIndex(year => year.id === this.componentActiveSchoolYearId)]
      if (this.calType === 'klass') {
        this.calStartDate = activeSchoolYear.student_time_start
        this.calEndDate = activeSchoolYear.student_time_end
      } else {
        this.calStartDate = activeSchoolYear.employee_time_start
        this.calEndDate = activeSchoolYear.employee_time_end
      }
      const start = moment(this.calStartDate).day(this.firstDayOfTheWeek)
      const end = moment(this.calEndDate).endOf('isoweek')
      let startWeek = moment(start).isoWeek()
      let diff = moment(end).diff(start, 'week')
      let max = startWeek + diff
      let weeks = []
      for (let i = startWeek; i <= max; i++) {
        let date = moment(start).isoWeek(i).day(this.firstDayOfTheWeek)
        weeks.push({
          date: date,
          serverDate: moment(date).format('YYYY-MM-DD'),
          weekNum: date.isoWeek()
        })
      }
      return weeks
    },
    firstDayOfTheWeek () {
      return this.$store.getters.firstDayOfWeek
    }
  },
  watch: {
    copyEventEvent (val) {
      if (val) {
        this.event = val
        this.openDropdown()
      }
    }
  },
  methods: {
    setInitialActivatedSchoolYear () {
      if (this.activeSchoolYear && this.activeSchoolYear.id) {
        this.componentActiveSchoolYearId = this.activeSchoolYear.id
      }
    },
    createPopper () {
      const parentPopper = document.querySelector('#vue-popper__copy_event_button')
      const childPopper = this.$refs.copy_event_panel
      document.getElementById('djs-content-container').appendChild(childPopper)
      createPopper(parentPopper, childPopper, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 5]
            }
          }
        ]
      })
    },
    tooltipDate (date) {
      let start = moment(date)
      let start2 = moment(date).format('DD. MMM')
      let startFormat = start.format('DD')
      let end = moment(date).add(6, 'days')
      let endFormat = moment(date).add(6, 'days').format('DD. MMM YYYY')
      // If same month
      if (moment(start).format('MM') === moment(end).format('MM')) {
        return startFormat + ' - ' + endFormat
      } else {
        return start2 + ' - ' + endFormat
      }
    },
    setSelectedWeek (week) {
      if (this.isCopyWeek(week)) {
        return
      }
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      if (idx < 0) {
        this.selectedWeeks.push(week.serverDate)
      } else {
        this.selectedWeeks.splice(idx, 1)
      }
    },
    isWeekSelected (week) {
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      return idx > -1
    },
    isCopyWeek (week) {
      return moment(week.date).format('GGGG-WW') === moment(this.copyDate).format('GGGG-WW')
    },
    isNow (week) {
      return moment(week.date).format('GGGG-WW') === moment().format('GGGG-WW')
    },
    submit () {
      const eventId = this.event.event_id ? this.event.event_id : this.event.id
      const schoolId = this.event.school_id ? this.event.school_id : window.SCHOOL.id
      console.log(this.event, {eventId, schoolId})
      docendo.subjectEventsCreate(schoolId, this.event.calendar_id, this.copyDate, this.selectedWeeks, false, null, null, [], [eventId], success => {
        // To close event preview panel in ROR
        this.closeDropdown()
        setTimeout(_ => {
          document.querySelector('.calendar').click()
        }, 0)
        eventbus.toast = {text: this.$i18n.t('vue2.copycalendar.noticationMessage'), success: false}
      }, failure => {
        this.closeDropdown()
        console.log('failure', failure)
      })
    },
    openDropdown () {
      this.setInitialActivatedSchoolYear()
      this.isDropdown = true
      this.getCalendar()
      this.$nextTick(_ => {
        this.createPopper()
        this.isDropdownPopperDone = true
        document.getElementById('djs-content-container').appendChild(this.$refs.d_copy_event_overlay)
      })
    },
    closeDropdown () {
      if (!this.isDropdown) {
        return
      }
      this.isDropdown = false
      this.isDropdownPopperDone = false
      eventbus.copyEventEvent = null
      this.removeAllSelectedWeeks()
      this.calStartDate = null
      if (this.$refs.d_copy_event_overlay) {
        this.$refs.d_copy_event_overlay.remove()
      }
    },
    selectWeek (week) {
      if (this.isCopyWeek(week)) {
        return
      }
      let idx = this.selectedWeeks.indexOf(week.serverDate)
      if (idx < 0) {
        this.selectedWeeks.push(week.serverDate)
      }
    },
    selectEvenWeeks () {
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          if (this.isEven(week.weekNum)) {
            this.selectWeek(week)
          }
        }
      })
    },
    selectOddWeeks () {
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          if (this.isOdd(week.weekNum)) {
            this.selectWeek(week)
          }
        }
      })
    },
    isEven (n) {
      return /^-?\d*[02468]$/.test(n)
    },
    isOdd (n) {
      return /^-?\d*[13579]$/.test(n)
    },
    addAllWeeksOnward () {
      this.weeks.forEach(week => {
        if (moment(week.date).isSameOrAfter(this.copyDate)) {
          this.selectWeek(week)
        }
      })
    },
    removeAllSelectedWeeks () {
      this.selectedWeeks = []
    },
    getCalendar () {
      docendo.calendar(this.event.calendar_id, data => {
        this.cal = data
        this.calType = data.type
        this.setCalStartAndEndDate()
      }, failure => {
        console.log('failed to get calendar', failure)
      })
    },
    setCalStartAndEndDate () {
      let highestIdx = 0
      this.activeSchoolYears.forEach((year, idx) => {
        if (idx > highestIdx) {
          highestIdx = idx
        }
        let startDate
        let endDate
        if (this.calType === 'klass') {
          startDate = moment(year.student_time_start).startOf('isoweek')
          endDate = moment(year.student_time_end).endOf('isoweek')
        } else {
          startDate = moment(year.employee_time_start).startOf('isoweek')
          endDate = moment(year.employee_time_end).endOf('isoweek')
        }
        if (moment(this.copyDate).isSame(startDate) || moment(this.copyDate).isBetween(startDate, endDate)) {
          this.componentActiveSchoolYearId = this.activeSchoolYears[idx].id
        }
      })
      if (!this.componentActiveSchoolYearId) {
        this.componentActiveSchoolYearId = this.activeSchoolYears[highestIdx].id
      }
    }
  },
  beforeDestroy () {
    eventbus.copyEventEvent = null
    if (this.$refs.copy_event_panel) {
      this.$refs.copy_event_panel.remove()
    }
    if (this.$refs.d_copy_event_overlay) {
      this.$refs.d_copy_event_overlay.remove()
    }
  }
}
</script>

<style>

.copy-event {
  position: absolute;
  z-index: 121212;
  width: 600px;
}

.copy-event__overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 12121;
}

.copy-event__panel {
  position: relative;
  background: #ffffff;
  border-radius: 4px;
  min-width: 240px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  user-select: none;
}

.copy-event__panel__close-cross {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #ffffff;
}

.copy-event__panel h3 {
  padding: 2rem 1rem;
  background: #e74c3c;
  color: #ffffff;
}

.copy-event__panel__container {
  display: flex;
  align-items: stretch;
}

.copy-event__panel .weeks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-width: 418px;
  padding: 3px;
  margin-top: 0;
}

.copy-event__panel__container .weeks__week {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  height: 42px;
  width: 42px;
  margin: 2px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #edf0f5;
  user-select: none;
  transition: all .25s;
}


.weeks__week:hover {
  border-color: var(--blue);
}

.weeks__week:active {
  transform: scale(0.9);
}

.weeks__week--is-selected {
  background-color: #468ad7;
  color: #fff;
}

.copy-event__panel__sidebar {
  border-left: 1px solid #e4e4e4;
  box-sizing: border-box;
  background-color: #fafafa;
  overflow: auto;
  padding: 1rem;
  min-width: 160px;
}

.copy-event__panel__sidebar button {
  margin-top: 1rem;
  outline: none;
  transition: transform 0.25s;
}

.copy-event__panel__sidebar button:active {
  transform: scale(0.95);
}

.weeks__week--is-copy-week {
  background: #3e4450 !important;
  color: #fff !important;
  border: none !important;
}

.copy-event__panel__sidebar .btn-remove {
  color: #fa565a;
}

.copy-event__panel__footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fafafa;
  box-shadow: inset 0 1px 0 0 #e6e8eb;
}

.weeks__week__now-indicator {
  z-index: 100;
  background: #468ad7;
  border-radius: 50%;
  display: block;
  height: .5em;
  left: 50%;
  bottom: 5px;
  margin: 0 0 0 -.22em;
  position: absolute;
  width: .5em;
}

.weeks__week--is-selected .weeks__week__now-indicator, .weeks__week--is-copy-week .weeks__week__now-indicator {
  background: #fff;
}

.school-year-selector {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// CopyEvent.vue?008c2f00